export type StaffAvatarTone = "rose" | "sky" | "mint" | "gold" | "plum" | "ink";

const STAFF_AVATAR_TONES: StaffAvatarTone[] = [
  "rose",
  "sky",
  "mint",
  "gold",
  "plum",
  "ink",
];

const hashStaffAvatarSeed = (value: string): number =>
  Array.from(value).reduce(
    (hash, character) => (hash * 31 + character.charCodeAt(0)) >>> 0,
    0,
  );

export const getStaffAvatarTone = (
  value: string | null | undefined,
): StaffAvatarTone => {
  const trimmedSeed = value?.trim().toLowerCase();
  const seed =
    trimmedSeed === undefined || trimmedSeed === ""
      ? "admin operator"
      : trimmedSeed;
  return STAFF_AVATAR_TONES[
    hashStaffAvatarSeed(seed) % STAFF_AVATAR_TONES.length
  ];
};

export const getStaffAvatarInitials = (
  value: string | null | undefined,
): string => {
  const trimmed = value?.trim();
  if (!trimmed) {
    return "NA";
  }

  return trimmed
    .split(/\s+/)
    .filter(Boolean)
    .map((chunk) => chunk.charAt(0))
    .join("")
    .slice(0, 2)
    .toUpperCase();
};
